import { Pipe, PipeTransform } from "@angular/core";
import moment from "moment";

@Pipe({
  name: "millisecondDuration",
  standalone: false,
})
export class MillisecondDurationPipe implements PipeTransform {
  transform(value: number): string {
    if (value < 0) return "00:00:00";

    const duration: moment.Duration = moment.duration(value * 1000);

    if (duration.days() >= 1) {
      return "> 1 day";
    } else {
      return moment.utc(duration.as("milliseconds")).format("HH:mm:ss");
    }
  }
}
